import _ from 'lodash';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Stack } from 'react-spark';

import { offersSchema } from '../../offers-page-schemas';

import Offer from '../offer/Offer';

export class OffersList extends Component {
    render() {
        const { sortedOffers } = this.props.offers;

        const offers = _.map(sortedOffers, (offer) => (
            <Stack.Item
                breakpoint="small"
                width="half"
                className="sprk-o-Box--tiny"
                key={offer.id}
            >
                <Offer detailedInfo heading="Loan Amount" keyName={offer.id} value={offer}></Offer>
            </Stack.Item>
        ));

        return (
            <Stack splitAt="small">{offers}</Stack>
        );
    }
}

OffersList.propTypes = {
    offers: offersSchema.isRequired
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OffersList);
